import React, { useState, useEffect } from "react"
import { Button, Input, Label } from "reactstrap"
import { getLOBStart } from "store/SuperAdmin/Lob-SubLob-company-income/action"
import { UpdateSubLOBStart } from "store/SuperAdmin/Lob-SubLob-company-income/subLobaction"

import { useDispatch, useSelector } from "react-redux"

const SuperSubLob = ({updateData}) => {
  const dispatch = useDispatch()
  const [data, setData] = useState({
    lob_id: "",
    SubLob: "",
  })

  const { loading, LOB, updated, Iscreated, deleted } = useSelector(
    state => state.SuperAdminLob
  )

  const handleChange = e => {
    const { name, value } = e.target
    setData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(UpdateSubLOBStart(data))
  }

  useEffect(() => {
    dispatch(getLOBStart())
  }, [])
  useEffect(() => {
    if (updateData && updateData.length > 0) {
      const Lobs = updateData[0];
      setData({
        lob_id: Lobs.id || "",
        SubLob: Lobs.SubLOB || "",
      });
    }
  }, [updateData]);

  console.log(data)

  return (
    <>
      <Label>Lob</Label>
      <span className="text-danger">*</span>
      <select
        className="form-select"
        aria-label="Default select example"
        name="lob_id"
        value={data.lob_id}
        onChange={handleChange}
      >
        <option>Select LOB</option>
        {LOB.data ? (
          LOB.data.map((item, idx) => (
            <option key={idx} value={item.id}>
              {item.LOB}
            </option>
          ))
        ) : (
          <option>Loading...</option>
        )}
      </select>

      <Label className="mt-3">Sub LOB</Label>
      <span className="text-danger">*</span>
      <Input
        name="SubLob"
        placeholder="Enter Sub Lob"
        value={data.SubLob}
        onChange={handleChange}
      />

      <Button
        type="submit"
        className="btn btn-dark mt-4"
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </>
  )
}

export default SuperSubLob
